import React from 'react';
// scss
import './SubmitMsg.scss';

const SubmitMsg = ({ text, handleCancel, handleSubmit  }) => {
  return (
    <div className='submit-msg'>
      <h2 className="submit-msg__text">{text}</h2>
      <div className="submit-msg__btn-wrap">
        <button type="button" className='submit-msg__btn submit-msg__btn--cancel' onClick={handleCancel}>Ні</button>
        <button type="button" className='submit-msg__btn submit-msg__btn--submit' onClick={handleSubmit}>Так</button>
      </div>
    </div>
  )
}

export default SubmitMsg